import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchFavorites, toggleFavorite } from '../services/projectService';
import { useOrgStore } from '../store/orgStore';

export function useProjectFavorites() {
  const activeOrgId = useOrgStore((s) => s.activeOrgId);
  return useQuery({
    queryKey: ['projects', 'favorites', activeOrgId],
    queryFn: fetchFavorites,
    staleTime: 30_000,
    enabled: !!activeOrgId,
  });
}

export function useToggleProjectFavorite() {
  const activeOrgId = useOrgStore((s) => s.activeOrgId);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (projectId: string) => toggleFavorite(projectId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects', 'favorites', activeOrgId] });
      queryClient.invalidateQueries({ queryKey: ['projects', activeOrgId ?? 'none'] });
    },
  });
}
